import { render, staticRenderFns } from "./VendorSignupTilled.vue?vue&type=template&id=12e2e9b0&scoped=true"
import script from "./VendorSignupTilled.vue?vue&type=script&lang=js"
export * from "./VendorSignupTilled.vue?vue&type=script&lang=js"
import style0 from "./VendorSignupTilled.vue?vue&type=style&index=0&id=12e2e9b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2e9b0",
  null
  
)

export default component.exports